import { useState } from "react";

const useOpen = (initialState: boolean) => {
  const [open, setOpen] = useState(initialState);

  const toggle = () => setOpen((prev) => !prev);

  return { open, setOpen, toggle };
};

export default useOpen;
